import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Loader from '4all-ui/components/Loader';
import Button from '4all-ui/components/Button';
import Switch from '4all-ui/components/Switch';
import { NavTabs, NavTab } from '4all-ui/components/NavTabs';
import { TIMER } from '../../../../helpers/constants';
import * as styled from './style';
import TimeModal from '../../../../components/TimeModal';
import Formats from '../../../../helpers/formats';
import Exclamation from '../../../../components/Icons/Exclamation';
import Tooltip from '../../../../components/Tooltip';

const INITIAL_STATE = {
  data: {
    deliveryEstimatedTime: '',
    takeAwayEstimatedTime: '',
    deliveryEstimatedIdUnitTime: 1,
    takeAwayEstimatedIdUnitTime: 1,
  },
  baseData: {},
  showTimeModal: false,
  timeModalError: null,
  isDeliveryPersonally: false,
  isDeliveryPersonallyByMktp: false,
};

class HeaderPage extends Component {
  state = INITIAL_STATE;

  componentWillReceiveProps(nextProps) {
    if (Object.keys(nextProps.merchant).length) {
      const data = {
        deliveryEstimatedTime: nextProps.merchant.deliveryEstimatedTime || '0',
        takeAwayEstimatedTime: nextProps.merchant.takeAwayEstimatedTime || '0',
        deliveryEstimatedIdUnitTime: nextProps.merchant.deliveryEstimatedIdUnitTime,
        takeAwayEstimatedIdUnitTime: nextProps.merchant.takeAwayEstimatedIdUnitTime,
      };
      this.setState(prevState => ({
        ...prevState,
        data,
        baseData: data,
        isDeliveryPersonally: nextProps.merchant.deliveryPersonally,
        isDeliveryPersonallyByMktp: nextProps.merchant.hasDeliveryPersonally,
      }));
    }
  }

  changeDeliveryPersonally = async statusDeliveryPersonally => {
    this.setState({
      isDeliveryPersonally: statusDeliveryPersonally,
    });

    const { updateDeliveryPersonally } = this.props;

    await updateDeliveryPersonally({
      deliveryPersonally: statusDeliveryPersonally,
    });
  };

  onChange = e => {
    const { data } = this.state;

    this.setState(prevState => ({
      ...prevState,
      showEdit: true,
      data: {
        ...data,
        [e.target.name]: e.target.value ? parseInt(e.target.value, 10) : '',
      },
    }));
  };

  onChangeDelivery = value => {
    const { data } = this.state;
    const deliveryEstimatedIdUnitTime = value ? parseInt(value, 10) : '';

    this.setState({
      data: {
        ...data,
        deliveryEstimatedIdUnitTime,
      },
    });
  };

  onChangeTakeaway = value => {
    const { data } = this.state;
    const takeAwayEstimatedIdUnitTime = value ? parseInt(value, 10) : '';

    this.setState({
      data: {
        ...data,
        takeAwayEstimatedIdUnitTime,
      },
    });
  };

  getOptionSelected = selected => TIMER.find(option => option.value === selected);

  handleTimeSave = async (e, data) => {
    e.preventDefault();

    this.setState({ timeModalError: null });

    const { updateTimes } = this.props;
    const response = await updateTimes(data);

    if (response.status === 204) {
      this.setState({ showTimeModal: false });
    } else {
      this.setState({ timeModalError: 'Preencha os campos corretamente' });
    }
  };

  handleModalClose = () => {
    this.setState({
      showTimeModal: false,
      timeModalError: null,
    });
  };

  render() {
    const {
      data,
      showTimeModal,
      timeModalError,
      isDeliveryPersonally,
      isDeliveryPersonallyByMktp,
    } = this.state;
    const { merchantIsFetching, merchantIsUpdating } = this.props;

    return (
      <Fragment>
        <styled.Container>
          <styled.Row>
            <styled.Content>
              <styled.Title>Pedidos</styled.Title>
            </styled.Content>
          </styled.Row>

          <styled.Row>
            <styled.Content as="nav">
              <NavTabs>
                <NavTab id="nav-link-product-list" path="/" activeClassName="active" height="60px">
                  Listagem de Pedidos
                </NavTab>
              </NavTabs>

              <styled.SubHeader>
                <styled.SubHeaderItem>
                  <styled.SubHeaderTitle>Espera Delivery</styled.SubHeaderTitle>
                  <styled.SubHeaderContent>
                    {merchantIsFetching
                      ? 'Carregando...'
                      : `${data.deliveryEstimatedTime} ${
                          Formats.getTimerValue(data.deliveryEstimatedIdUnitTime).label
                        }`}
                  </styled.SubHeaderContent>
                </styled.SubHeaderItem>

                <styled.SubHeaderItem>
                  <styled.SubHeaderTitle>Espera Takeaway</styled.SubHeaderTitle>
                  <styled.SubHeaderContent>
                    {merchantIsFetching
                      ? 'Carregando...'
                      : `${data.takeAwayEstimatedTime} ${
                          Formats.getTimerValue(data.takeAwayEstimatedIdUnitTime).label
                        }`}
                  </styled.SubHeaderContent>
                </styled.SubHeaderItem>

                {isDeliveryPersonallyByMktp && (
                  <styled.SubHeaderItem alignDeliveryPersonally>
                    <styled.SubHeaderTitle>
                      Entrega em Mãos
                      <Tooltip
                        text="Essa opção torna possível para o cliente,
                        receber o pedido fora da mesa e em qualquer lugar do
                        estabelecimento"
                        textColor="#fff"
                        boxColor="rgba(51, 51, 51, 0.6)"
                      >
                        <Exclamation className="iconTooltip" style={{ marginLeft: '5px' }} />
                      </Tooltip>
                    </styled.SubHeaderTitle>

                    <Switch
                      id="switch_status_product"
                      checked={isDeliveryPersonally}
                      size="small"
                      onChange={() => this.changeDeliveryPersonally(!isDeliveryPersonally)}
                    >
                      <styled.SubHeaderItem>
                        <styled.SwitchText isDeliveryPersonally={isDeliveryPersonally}>
                          Habilitado
                        </styled.SwitchText>
                      </styled.SubHeaderItem>
                    </Switch>
                  </styled.SubHeaderItem>
                )}

                <Button
                  secondary
                  customStyles={{ marginLeft: 25 }}
                  type="button"
                  onClick={() => this.setState({ showTimeModal: true })}
                >
                  Ajustar Espera
                </Button>
              </styled.SubHeader>
            </styled.Content>
          </styled.Row>
        </styled.Container>

        <TimeModal
          data={data}
          show={showTimeModal}
          error={timeModalError}
          onSave={this.handleTimeSave}
          onClose={this.handleModalClose}
          merchantIsUpdating={merchantIsUpdating}
        />

        {merchantIsUpdating && (
          <styled.LoaderContainer>
            <Loader size="60px" />
          </styled.LoaderContainer>
        )}
      </Fragment>
    );
  }
}

HeaderPage.propTypes = {
  merchant: PropTypes.object,
  showEdit: PropTypes.bool,
  merchantIsFetching: PropTypes.bool,
  merchantIsUpdating: PropTypes.bool,
  updateTimes: PropTypes.func,
  updateDeliveryPersonally: PropTypes.func,
};

export default HeaderPage;



// WEBPACK FOOTER //
// ./src/screens/Home/Components/HeaderPage/index.js